export const saveTextFile = (mimeType, fileName, text) => {
  const blob = URL.createObjectURL(new Blob([text], { type: mimeType }))

  const el = document.createElement('a')
  el.download = `${fileName}.json`
  el.href = blob
  el.dataset.downloadurl = [mimeType, el.download, el.href].join(':')
  el.click()

  URL.revokeObjectURL(blob)
  el.remove()
}

export const saveJsonFile = (fileName, data) => {
  return saveTextFile(
    'application/json',
    fileName,
    JSON.stringify(data, null, 2)
  )
}

/** @type {(file: File) => Promise<string>} */
export const loadTextFile = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener('error', function () {
      reject(reader.error)
    })

    reader.addEventListener('load', function (e) {
      try {
        resolve(e.target.result)
      } catch (error) {
        reject(error)
      }
    })

    reader.readAsBinaryString(file)
  })

/** @type {(file: File) => Promise<string>} */
export const loadJsonFile = async file => {
  const text = await loadTextFile(file)
  return JSON.parse(text)
}
